/* eslint-disable */
import React from 'react';
import { RACThemeProvider, makeStyles } from '@rentacenter/racstrap';
import clsx from 'clsx';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const History = require('history');
import { Routes } from './Routes';
import { BrowserRouter } from 'react-router-dom';
import { ResidenceContextProvider } from '../context/userInformation/ResidenceContextProvider';
import { IncomeContextProvider } from '../context/userInformation/IncomeContextProvider';
import { IdentityContextProvider } from '../context/userInformation/IdentityContextProvider';

interface Props {
  history: typeof History;
}

export const appTestId = 'appTestId';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    // paddingLeft: '0.75rem',
    // paddingRight: '0.75rem',
  },
}));

export const App = ({ history }: Props) => {
  const classes = useStyles();

  return (
    <div data-testid={appTestId} >
      <RACThemeProvider>
        <div className={clsx(classes.container)}>
          <IdentityContextProvider>
            <IncomeContextProvider>
              <ResidenceContextProvider>
                <BrowserRouter>
                  <Routes />
                </BrowserRouter>
              </ResidenceContextProvider>
            </IncomeContextProvider>
          </IdentityContextProvider>
        </div>
      </RACThemeProvider>
    </div>
  );
};
